import { useEffect, useState } from 'react';

interface ConfettiPiece {
  id: number;
  x: number;
  y: number;
  rotate: number;
  delay: number;
  size: number;
}

interface ConfettiProps {
  active: boolean;
}

const CONFETTI_COUNT = 14;

export const Confetti = ({ active }: ConfettiProps) => {
  const [pieces, setPieces] = useState<ConfettiPiece[]>([]);

  useEffect(() => {
    if (!active) return;

    setPieces(
      Array.from({ length: CONFETTI_COUNT }, (_, index) => {
        const angle = Math.random() * Math.PI * 2;
        const distance = 25 + Math.random() * 30;

        return {
          id: index,
          x: Math.cos(angle) * distance,
          y: Math.sin(angle) * distance,
          rotate: Math.random() * 720 - 360,
          delay: Math.random() * 150,
          size: 3 + Math.random() * 3,
        };
      }),
    );

    const timeout = window.setTimeout(() => {
      setPieces([]);
    }, 900);

    return () => window.clearTimeout(timeout);
  }, [active]);

  if (!pieces.length) return null;

  return (
    <span className="tw-pointer-events-none tw-absolute tw-inset-0 tw-overflow-visible">
      {pieces.map((piece) => (
        <span
          key={piece.id}
          className="tw-absolute tw-left-1/2 tw-top-1/2 tw-rounded-[1px] tw-bg-primary/80 tw-animate-confetti"
          style={
            {
              width: `${piece.size}px`,
              height: `${piece.size * 1.8}px`,
              '--confetti-x': `${piece.x}px`,
              '--confetti-y': `${piece.y}px`,
              '--confetti-rotate': `${piece.rotate}deg`,
              '--confetti-delay': `${piece.delay}ms`,
            } as React.CSSProperties
          }
        />
      ))}
    </span>
  );
};
